import {AttrsSchema, Component} from 'panel';

import {propagateEvent} from 'common/util/dom';
import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {trackUpsellEvent} from 'common/report/util/tracking-helpers';

import {template} from './template';
import css from './index.styl?inline';

export type UpsellModalAttrs = {
  closeable: boolean;
  description: string;
  'feature-gate-type': `string`;
  header: string;
  'learn-more-url': string;
  open: boolean;
  'upgrade-text': string;
};

export type UpsellModalState = {
  open: boolean;
  backgroundImage: string;
};

export class UpsellModal extends Component<UpsellModalState, UpsellModalAttrs> {
  static get attrsSchema(): AttrsSchema<UpsellModalAttrs> {
    return {
      closeable: `boolean`,
      description: `string`,
      'feature-gate-type': `string`,
      header: `string`,
      'learn-more-url': `string`,
      open: `boolean`,
      'upgrade-text': {type: `string`, default: `Upgrade Your Plan`},
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
      helpers: {
        handleModalChange: (ev) => {
          if (ev.detail.state === `closed`) {
            this.updateVisibility(false);
          }
          propagateEvent(this, ev);
        },
        handleClickCancel: () => this.updateVisibility(false),
        handleClickUpgrade: () => {
          trackUpsellEvent(`Click Upsell`, this.attr(`feature-gate-type`));
        },
      },
    };
  }

  disconnectedCallback() {
    this.updateVisibility(false);
    super.disconnectedCallback();
  }

  updateVisibility(open) {
    this.update({open});
    if (open) {
      trackUpsellEvent(`View Upsell`, this.attr(`feature-gate-type`));
    }

    const chromeHeaderEl = document.querySelector<HTMLElement>(`mp-chrome-header`);
    if (chromeHeaderEl) {
      // mp-chrome-header exists when in the context of the site, but not for standalone, tests, etc...
      // TODO: Dirty GOOT hack to allow nav access when upsell modal is present.
      chromeHeaderEl.style.zIndex = open ? `9999` : ``;
    }
  }

  attributeChangedCallback(name: string, oldValue: string | null, newValue: string | null) {
    super.attributeChangedCallback(name, oldValue, newValue);
    if (name === `open`) {
      this.updateVisibility(this.attr(name));
    }
  }

  set backgroundImage(backgroundImage) {
    this.update({backgroundImage});
  }
}
export const UpsellModalEl = defineAndMakeJsxFactory(`mp-upsell-modal`, UpsellModal);
